import Icon from "./icon.vue";
export default {
  name: "FormControls",
  components: {
    Icon
  },
  props: {
    errorMessage: String,
    buttonText: !String,
    state: !String
  }
};